import FJCanvasStore from "../../store/FJCanvasStore";
import FJActionConstant from "../../constant/FJActionConstant";
import FJCoreConstant from "../../core/constant/FJCoreConstant";
import {FJFontManager, FJConstant} from "fj-graph";
import {
  FJFilterAction,
  FJFontAction,
  FJMediaAction,
  FJModalAction,
  FJPreviewAction,
  FJResourceAction,
  FJTimeLineAction
} from "./FJRoot.action";
import _ from 'lodash'
import FJCoreUtil from "../../core/util/FJCoreUtil";
import FJUtil from "../../util/FJUtil";
import FJConfig from "../../config/FJConfig";
import FJViewConstant from "../../constant/FJViewConstant";
import FJIntroOutroStore from "../../store/FJIntroOutroStore";
import FJMediaCacheStore from "../../store/FJMediaCacheStore";
import FJLocalStore from "../../store/FJLocalStore";
import FJMessageStore from "../../store/FJMessageStore";

let FJToolbarAction = (function () {
  /**
   * @description 根据字体名称返回是否加粗，是否斜体
   * @param fontName
   * @returns {{disableItalic: boolean, disableBold: boolean}}
   */
  function fontStyleDisableData(fontName) {
    let item = FJFontManager.fontItemWithName(fontName);
    if (!item)
      return {
        disableBold: false,
        disableItalic: false,
      };

    let fontFamilyList = item.family;
    let style = {
      disableBold: false,
      disableItalic: false,
    };
    if (fontFamilyList.indexOf('n7') === -1) {
      style.disableBold = true;
    }
    if (fontFamilyList.indexOf('i4') === -1) {
      style.disableItalic = true;
    }
    return style;
  }

  return {

    /**
     * @description 更新当前选中对象的工具条信息
     * @return {Function}
     */
    updateToolbarAction: function () {
      return (dispatch, getState) => {
        let lastType = getState().resource.lastType;
        let showType = getState().resource.showType;
        let mediaList = getState().media.mediaList;
        let {GET_SELECTED_AND_IS_RENDER_GRAPH, GET_SELECTED_AND_COULD_OPERATE_EDIT} = FJCanvasStore.command;
        let graphObj = FJCanvasStore.executeSync(GET_SELECTED_AND_IS_RENDER_GRAPH);
        if (graphObj) {

          // subGraph存在时说明graph是组
          let {graph, subGraph} = graphObj;
          let type = subGraph ? subGraph.type : graph.type;
          let {
            VIDEO,
            IMAGE,
            AUDIO,
            TEXT_ANIMATION,
            BACKGROUND,
            WIDGET,
            MULTI_WIDGET,
            SVG,
            STATIC_IMAGE,
            SHAPE,
            OVERLAY,
            TEXT,
            DECORATION_OVERLAY,
            DYNAMIC_LOGO,
          } = FJCoreConstant;
          let relativeRect = graph.getRelativeRect() ? graph.getRelativeRect() : {x: 0, y: 0, width: 1, height: 1};
          let updateCropFunc = (graph) => {
            let maskType = 0;
            switch (graph.getCropType()) {
              case FJConstant.CROP_TYPE_SQUARE:
                maskType = 1;
                break;
              case FJConstant.CROP_TYPE_CIRCLE:
                maskType = 2;
                break;
              default:
            }
            dispatch(this.setMaskEnableAction(!!graph.sourceId));
            dispatch(this.setMaskAction(maskType));
            dispatch(this.setCropModeAction(graph.getCropMode()));
          };
          let updateFilterAndAdjustFunc = () => {
            let filter = graph.getFilter();
            let adjust = {...graph.getAdjustFilter()};
            dispatch(FJFilterAction.setFilterTypeAction(filter.type));
            dispatch(FJFilterAction.setIntensityAction(filter.intensity * 100));
            dispatch(FJFilterAction.setFilterActiveAction(filter.active));
            dispatch(FJFilterAction.setAdjustActiveAction(adjust.active));
            dispatch(FJFilterAction.updateAdjustDisabledAction());

            delete adjust.active
            for (let key in adjust) {
              if (Object.hasOwnProperty.call(adjust, key)) {
                adjust[key] = adjust[key] * 100;
              }
            }
            dispatch(FJFilterAction.setAdjustDataAction(adjust));
          };
          dispatch(this.updateToolbarTypeAction(type));

          // svg动画插槽、图片动画、滤镜这些toolbar类型的特殊处理
          if (type !== SVG && type !== IMAGE && type !== VIDEO && lastType) {
            dispatch(FJResourceAction.setShowTypeAction(lastType));
          }

          let getMediaName = () => {
						let media = mediaList.find(media => media.id === graph.sourceId);
						if (media) return media.name;
						return ''
					}

          switch (type) {
            case VIDEO:
              dispatch(this.setMediaStatusAction(type, graph.getMediaStatus()))
							dispatch(this.setMediaNameAction(type, getMediaName()))
              dispatch(this.setVideoVolumeAction(graph.getVolume() * 100));
              dispatch(this.setMediaOpacityAction(graph.getOpacity() * 100));
              dispatch(this.setVideoSpeedAction(graph.getSpeed()));
              if (FJConfig.enableMainTrackEditMode) {
                dispatch(this.setEditorModeAction(graph.getControlEnable()));
                dispatch(this.setShowEditorModeAction(FJCanvasStore.executeSync(GET_SELECTED_AND_COULD_OPERATE_EDIT)));
              }
              if (!graph.getCropMode()) {
                dispatch(this.setVideoZoomScaleAction(relativeRect.width * 100));
              }
              updateCropFunc(graph);
              updateFilterAndAdjustFunc(graph);
              break;
            case IMAGE:
              dispatch(this.setMediaStatusAction(type, graph.getMediaStatus()))
							dispatch(this.setMediaNameAction(type, getMediaName()))
              dispatch(this.setMediaOpacityAction(graph.getOpacity() * 100));
              if (FJConfig.enableMainTrackEditMode) {
                dispatch(this.setEditorModeAction(graph.getControlEnable()));
                dispatch(this.setShowEditorModeAction(FJCanvasStore.executeSync(GET_SELECTED_AND_COULD_OPERATE_EDIT)));
              }
              if (!graph.getCropMode()) {
                dispatch(this.setPhotoZoomScaleAction(relativeRect.width * 100));
              }
              dispatch(this.setPhotoAnimationAction(graph.getAnimationType()));
              updateCropFunc(graph);
              updateFilterAndAdjustFunc(graph);
              break;
            case AUDIO:
              dispatch(this.setMediaStatusAction(type, graph.getMediaStatus()))
              dispatch(this.setAudioFadeInAction(graph.getFadeInTime()));
              dispatch(this.setAudioFadeOutAction(graph.getFadeOutTime()));
							dispatch(this.setMediaNameAction(type, getMediaName()))
              dispatch(this.setAudioVolumeAction(graph.getVolume() * 100));
              break;
            case TEXT_ANIMATION:
              dispatch(this.updateTextAnimationColorAction(graph.getMainColor(), graph.getSubColor()));
              dispatch(this.updateTextAnimationAlignmentAction(graph.getAlignment()));
              dispatch(this.updateTextAnimationColorLengthAction(graph.colorLength));
              dispatch(this.updateTextAnimationTextLengthAction(graph.textLength));
              dispatch(this.updateTextAnimationBoldAction(graph.getBold()));
              dispatch(this.updateTextAnimationItalicAction(graph.getItalic()));
              dispatch(this.updateFontFamilyAction(graph.getFontFamily()));
              dispatch(this.updateTextAnimationContentAction(graph.getTextData()));
              break;
            case BACKGROUND:
              dispatch(this.updateBackgroundColorAction(graph.getBackgroundColor()));
              break;
            case WIDGET:
            case MULTI_WIDGET:
              dispatch(this.setMediaOpacityAction(graph.getOpacity() * 100));
              dispatch(this.updateWidgetColorAction(graph.getColors()));
              break;
            case SVG: {
              dispatch(this.setMediaOpacityAction(graph.getOpacity() * 100));
              dispatch(this.updateSvgColorAction(graph.getColors()));
              let animationIntroSlot = graph.getAnimationSlot(FJViewConstant.INTRO);
              dispatch(FJMediaAction.setAnimationIntroSlot(FJIntroOutroStore.coreNameToViewName(animationIntroSlot && animationIntroSlot.name)));
              let animationOutroSlot = graph.getAnimationSlot(FJViewConstant.OUTRO);
              dispatch(FJMediaAction.setAnimationOutroSlot(FJIntroOutroStore.coreNameToViewName(animationOutroSlot && animationOutroSlot.name)));
              break;
            }
            case STATIC_IMAGE:
              updateCropFunc(subGraph);
              dispatch(this.updateOverlayPosition(graph.supportPositions, graph.getPosition()));
              dispatch(this.setMediaStatusAction(type, subGraph.getMediaStatus()))
              break;
            case DECORATION_OVERLAY:
              dispatch(this.updateWidgetColorAction(graph.getColors()));
              break;
            case OVERLAY:
            case SHAPE:
            case DYNAMIC_LOGO:

              // 选中shape等价于选中整个graph
              dispatch(this.updateOverlayColorsAction(graph.getAllColors()));
              dispatch(this.updateTextAnimationContentAction(graph.getTextData()));
              dispatch(this.updateTextAnimationTextLengthAction(graph.getTextData().length));
              dispatch(this.updateOverlayPosition(graph.supportPositions, graph.getPosition()));
              break;
            case TEXT:
              dispatch(this.updateOverlayPosition(graph.supportPositions, graph.getPosition()));
              dispatch(this.updateFontFamilyAction(subGraph.getFontFamily()));
              dispatch(this.updateOverlayColorsAction([subGraph.getColor()]));
              dispatch(this.updateOverlayTextBoldAction(subGraph.getBold()));
              dispatch(this.updateOverlayTextItalicAction(subGraph.getItalic()));
              dispatch(this.updateTextAnimationContentAction(graph.getTextData()));
              dispatch(this.updateTextAnimationTextLengthAction(graph.getTextData().length));
              break;
            default:
          }
        } else if (lastType && lastType !== showType) {
          dispatch(this.updateToolbarTypeAction(''));
          dispatch(FJResourceAction.setShowTypeAction(lastType));
        } else {
          dispatch(this.updateToolbarTypeAction(''));
        }
      };
    },

    /**
     * @description 更新工具条类型
     * @param type
     * @return {{selectedType: *, type: string}}
     */
    updateToolbarTypeAction: function (type) {
      return {
        type: FJActionConstant.TOOLBAR_TYPE_CHANGED,
        selectedType: type,
      }
    },

    /**
     * @description 修改文字动画的内容
     * @param textData
     * @returns {Function}
     */
    textContentChangeAction: function (textData) {
      return (dispatch, getState) => {
        let {TEXT_ANIMATION, TEXT, SHAPE, OVERLAY, DYNAMIC_LOGO} = FJConstant;
        let {selectedType} = getState().toolbar;
        if (JSON.stringify(textData) !== JSON.stringify(getState().toolbarText.textData)) {
          switch (selectedType) {
            case TEXT_ANIMATION: {
              let {length} = getState().toolbarText;
              let textIsNull;
              if(length === 1) {
                textIsNull = textData[0].length === 1 && textData[0][0] === '';
              } else {
                textIsNull = textData.every((item) => {
                  return item.length === 1 && item[0] === '';
                });
              }
              if (textIsNull) {
                dispatch(this.toolbarDeleteAction());
              } else {
                FJCanvasStore.executeSync(FJCanvasStore.command.SET_TEXT_ANIMATION_DATA, {textData});
              }
              break;
            }
            case TEXT:
            case SHAPE:
            case OVERLAY:
            case DYNAMIC_LOGO:
              FJCanvasStore.executeSync(FJCanvasStore.command.SET_OVERLAY_DATA, {textData});
              break;
          }
          dispatch(this.updateTextAnimationContentAction(textData));
          dispatch(FJTimeLineAction.updateAllTimelineAction());
          dispatch(FJToolbarAction.updateToolbarAction());
        }
      };
    },

    /**
     * @description 更新文字动画内容
     * @param textData
     * @return {{textData: *, type: string}}
     */
    updateTextAnimationContentAction: function (textData) {
      return (dispatch, getState) => {
        if (JSON.stringify(textData) !== JSON.stringify(getState().toolbarText.textData)) {
          dispatch({
            type: FJActionConstant.SET_TEXT_ANIMATION_CONTENT,
            textData: _.cloneDeep(textData),
          });
        }
      };
    },

    /**
     * @description 更新文字默认焦点
     * @param focusIndex
     * @return {{textData: *, type: string}}
     */
    updateTextAnimationFocusIndexAction: function (focusIndex) {
      return {
        type: FJActionConstant.SET_TEXT_ANIMATION_FOCUS_INDEX,
        focusIndex,
      };
    },

    /**
     * @description 设置文字对齐
     * @param alignment {String} 居中 左， 右
     * @returns {Function}
     */
    setTextAnimationAlignmentAction: function (alignment) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_TEXT_ANIMATION_DATA, {alignment});
        dispatch(this.updateTextAnimationAlignmentAction(alignment));
      };
    },

    /**
     * @description 更新文字动画对齐
     * @param alignment
     * @return {{type: string, alignment: *}}
     */
    updateTextAnimationAlignmentAction: function (alignment) {
      return {
        type: FJActionConstant.SET_TEXT_ANIMATION_ALIGNMENT,
        alignment,
      };
    },

    /**
     * @description 更新文字内容上限，用于颜色组件是否为单色
     * @param colorLength
     */
    updateTextAnimationColorLengthAction: function (colorLength) {
      return {
        type: FJActionConstant.SET_TEXT_ANIMATION_COLOR_LENGTH,
        colorLength,
      }
    },

    /**
     * @description 更新文字内容上限，用于颜色组件是否为单色
     * @param textLength
     */
    updateTextAnimationTextLengthAction: function (textLength) {
      return {
        type: FJActionConstant.SET_TEXT_ANIMATION_TEXT_LENGTH,
        textLength,
      }
    },

    /**
     * @description 设置文字放大缩小
     * @param type
     * @returns {Function}
     */
    setTextAnimationZoomAction: function (type) {
      return (dispatch) => {
        switch (type) {
          case FJCoreConstant.ZOOM_IN:
            FJCanvasStore.executeSync(FJCanvasStore.command.SET_TEXT_ANIMATION_DATA, {zoomIn: true});
            break;
          case FJCoreConstant.ZOOM_OUT:
            FJCanvasStore.executeSync(FJCanvasStore.command.SET_TEXT_ANIMATION_DATA, {zoomOut: true});
            break;
          default:
        }
        dispatch(this.updateToolbarAction());
      };
    },

    /**
     * @description 设置文字是否粗体
     * @returns {Function}
     */
    setTextAnimationBoldAction: function () {
      return (dispatch, getState) => {
        let toolbarText = getState().toolbarText;
        let value = !toolbarText.bold;
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_TEXT_ANIMATION_DATA, {bold: value});
        dispatch(this.updateTextAnimationBoldAction(value));
      };
    },

    /**
     * @description 更新文字粗体
     * @param value
     * @return {{data: *, type: string}}
     */
    updateTextAnimationBoldAction: function (value) {
      return {
        type: FJActionConstant.SET_TEXT_ANIMATION_BOLD,
        data: value,
      };
    },

    /**
     * @description 设置文字是否斜体
     * @returns {Function}
     */
    setTextAnimationItalicAction: function () {
      return (dispatch, getState) => {
        let toolbarText = getState().toolbarText;
        let value = !toolbarText.italic;
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_TEXT_ANIMATION_DATA, {italic: value});
        dispatch(this.updateTextAnimationItalicAction(value));
      };
    },

    /**
     * @description 更新文字斜体
     * @param value
     * @return {{data: *, type: string}}
     */
    updateTextAnimationItalicAction: function (value) {
      return {
        type: FJActionConstant.SET_TEXT_ANIMATION_ITALIC,
        data: value,
      };
    },

    /**
     * @description 设置文字的位置
     * @param position
     * @returns {Function}
     */
    setTextAnimationPositionAction: function (position) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_TEXT_ANIMATION_DATA, {position});
        dispatch(this.updateToolbarAction());
      }
    },

    /**
     * @description 删除工具条对应的graph
     * @return {Function}
     */
    toolbarDeleteAction: function () {
      return (dispatch, getState) => {
        let selectedId = getState().timeline.selectedId;
        dispatch(FJTimeLineAction.deleteTimelineAction(selectedId));
      };
    },

    /**
     * @description 设置widget颜色
     * @param colors
     * @return {{type: string, colors: *}}
     */
    updateWidgetColorAction: function (colors) {
      return {
        type: FJActionConstant.SET_WIDGET_COLOR,
        colors,
      }
    },

    /**
     * @description 更新overlay/dynamicLogo位置
     * @param supportPositions
     * @param position
     * @return {{supportPositions: *, type: string}}
     */
    updateOverlayPosition: function (supportPositions, position) {
      return {
        type: FJActionConstant.SET_OVERLAY_POSITION,
        supportPositions,
        position,
      }
    },

    /**
     * @description 设置overlay颜色
     * @param colors
     * @return {{type: string, colors: *}}
     */
    updateOverlayColorsAction: function (colors) {
      return {
        type: FJActionConstant.SET_OVERLAY_COLORS,
        colors,
      }
    },

    /**
     * @description 更新overlay中文字的粗体信息
     * @param bold
     * @return {{bold: *, type: string}}
     */
    updateOverlayTextBoldAction: function (bold) {
      return {
        type: FJActionConstant.SET_OVERLAY_TEXT_BOLD,
        bold,
      }
    },

    /**
     * @description 更新overlay中文字的粗体信息
     * @param italic
     * @return {{bold: *, type: string}}
     */
    updateOverlayTextItalicAction: function (italic) {
      return {
        type: FJActionConstant.SET_OVERLAY_TEXT_ITALIC,
        italic,
      }
    },

    /**
     * @description 设置widget颜色
     * @param colors
     * @return {{type: string, colors: *}}
     */
    updateSvgColorAction: function (colors) {
      return {
        type: FJActionConstant.SET_SVG_COLOR,
        colors,
      }
    },

    /**
     * @description 修改widget颜色
     * @param type
     * @param colorData
     * @returns {Function}
     */
    setWidgetColorAction: function (type, colors) {
      return (dispatch) => {
        FJUtil.toggleScope(type);
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_WIDGET_DATA, colors, {
          type,
        });
        dispatch(this.updateWidgetColorAction(colors));
      }
    },

    /**
     * @description 修改svg颜色
     * @param type
     * @param colorData
     * @returns {Function}
     */
    setSvgColorAction: function (type, colors) {
      return (dispatch) => {
        FJUtil.toggleScope(type);
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_SVG_DATA, {colors}, {
          type,
        });
        dispatch(this.updateSvgColorAction(colors));
      }
    },

    /**
     * @description 设置overlay/dynamicLogo位置
     * @param position
     * @return {function(): void}
     */
    setOverlayPositionAction: function (position) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_OVERLAY_DATA, {position});
        dispatch(this.updateToolbarAction());
      }
    },

    /**
     * @description 设置overlay/dynamicLogo的整体颜色
     * @param type
     * @param color
     * @param index
     */
    setOverlayColorAction: function (type, color, index) {
      return (dispatch) => {
        FJUtil.toggleScope(type);
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_OVERLAY_DATA, {color, index}, {
          type,
        });
        dispatch(this.updateToolbarAction());
      }
    },

    /**
     * @description 设置overlay文字的字体
     * @param fontFamily
     */
    setOverlayTextFontFamilyAction: function (fontFamily) {
      return (dispatch, getState) => {
        const state = getState();
        const currentFontFamily = state.toolOverlay.fontFamily;
        if (fontFamily === currentFontFamily) {
          return
        }

        FJFontManager.loadFont(fontFamily, (result) => {

          dispatch(FJFontAction.updateLoadingFontAction(FJFontManager.loadingFonts()));
          // TODO 应用字体到画布
          FJCanvasStore.executeSync(FJCanvasStore.command.SET_OVERLAY_DATA, {fontFamily});
          dispatch(this.updateFontFamilyAction(fontFamily));
        });
        dispatch(FJFontAction.updateLoadingFontAction(FJFontManager.loadingFonts()));
      };
    },

    /**
     * @description 设置overlay/dynamicLogo文字粗体
     */
    setOverlayTextBoldAction: function () {
      return (dispatch, getState) => {
        let value = !getState().toolOverlay.bold;
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_OVERLAY_DATA, {bold: value});
        dispatch(this.updateToolbarAction());
      };
    },

    /**
     * @description 设置overlay/dynamicLogo文字斜体
     * @return {function(*, *): void}
     */
    setOverlayTextItalicAction: function () {
      return (dispatch, getState) => {
        let value = !getState().toolOverlay.italic;
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_OVERLAY_DATA, {italic: value});
        dispatch(this.updateToolbarAction());
      };
    },

    /**
     * @description 设置overlay/dynamicLogo文字颜色
     * @return {function(*, *): void}
     */
    setOverlayTextColorAction: function (type, colorData) {
      return (dispatch) => {
        let {mainColor} = colorData;
        FJUtil.toggleScope(type);
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_OVERLAY_DATA, {color: mainColor}, {
          type,
        });
        dispatch(this.updateToolbarAction());
      }
    },

    /**
     * @description 设置dynamicLogo图片旋转
     * @param {number <-1 | 1>} type -1为左侧旋转、1为右侧旋转
     * @return {function(*)}
     */
    setOverlayImageRotationAction: function (type) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_OVERLAY_DATA, {rotate: type});
        dispatch(this.updateToolbarAction());
      }
    },

    /**
     * @description 设置dynamicLogo图片资源
     * @param file
     */
    setOverlayImageSourceAction: function (file) {
      return async (dispatch) => {
        if (file) {
          try {
            let minResource = await FJUtil.compressImage(file, 500, 500);
            let sourceId = await FJUtil.hashEncode(minResource);
            let cache = await FJMediaCacheStore.setMediaCache(sourceId, minResource);
            let url = cache.getUrl();
            FJCanvasStore.executeSync(FJCanvasStore.command.SET_OVERLAY_DATA, {mediaData: {sourceId, url}});
            dispatch(this.updateToolbarAction());
          } catch (e) {
            console.log(e);
            dispatch(FJMediaAction.imageNotSupportAction());
          }
        }
      }
    },

    /**
     * @description 修改字体颜色
     * @param type
     * @param colorData
     * @returns {Function}
     */
    setTextAnimationColorAction: function (type, colorData) {
      return (dispatch) => {
        let {mainColor, subColor} = colorData;
        FJUtil.toggleScope(type);
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_TEXT_ANIMATION_DATA, {mainColor, subColor}, {
          type,
        });
        dispatch(this.updateTextAnimationColorAction(mainColor, subColor));
      }
    },

    /**
     * @description 更新文字颜色
     * @param mainColor
     * @param subColor
     * @return {{color1: *, color2: *, type: string}}
     */
    updateTextAnimationColorAction: function (mainColor, subColor) {
      return {
        type: FJActionConstant.SET_TEXT_ANIMATION_COLOR,
        color1: mainColor,
        color2: subColor,
      };
    },

    /**
     * @description 切换字体
     * @param fontFamily
     * @returns {Function}
     */
    setTextAnimationFontFamilyAction: function (fontFamily) {
      return (dispatch, getState) => {
        const state = getState();
        const currentFontFamily = state.toolbar.fontFamily;
        if (fontFamily === currentFontFamily) {
          return
        }

        FJFontManager.loadFont(fontFamily, () => {
          dispatch(FJFontAction.updateLoadingFontAction(FJFontManager.loadingFonts()));
          // TODO 应用字体到画布
          FJCanvasStore.executeSync(FJCanvasStore.command.SET_TEXT_ANIMATION_DATA, {fontFamily});
          dispatch(this.updateFontFamilyAction(fontFamily));
        });
        dispatch(FJFontAction.updateLoadingFontAction(FJFontManager.loadingFonts()));
      };
    },

    /**
     * @description 更新字体信息
     * @param fontFamily
     * @return {{fontFamily: *, type: string, disableItalic: boolean, disableBold: boolean}}
     */
    updateFontFamilyAction: function (fontFamily) {
      let fontStyle = fontStyleDisableData(fontFamily);
      return {
        type: FJActionConstant.UPDATE_FONTFAMILY,
        fontFamily: fontFamily,
        disableBold: fontStyle.disableBold,
        disableItalic: fontStyle.disableItalic,
      }
    },

    /**
     * @description 打开文字动画编辑文字面板
     * @returns {Function}
     */
    showEditTextPanelAction: function (index = 0) {
      return (dispatch) => {
        FJCoreUtil.triggerBodyMousedown();
        dispatch(FJToolbarAction.updateTextAnimationFocusIndexAction(index));
        dispatch(FJModalAction.setIsShowTextEditorModalAction(true));
      }
    },

    /**
     * @description video设置音量
     * @param type
     * @param volume
     */
    videoVolumeDataChangeAction: function (type, volume) {
      return (dispatch) => {
        FJUtil.toggleScope(type);
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_VIDEO_ATTRIBUTES_DATA, {volume: volume / 100}, {
          type,
        });

        if (type === 'slideStop') {
          FJUtil.ealog('timeline_adjust_volume', {
            location: 'toolbar',
          });
        }

        dispatch(this.setVideoVolumeAction(volume));
      };
    },

    /**
     * @description video设置速率
     * @param speed
     */
    videoSpeedChangeAction: function (speed) {
      return (dispatch) => {
        let success = FJCanvasStore.executeSync(FJCanvasStore.command.SET_VIDEO_ATTRIBUTES_DATA, {speed});
        if (success) {
          FJCanvasStore.execute(FJCanvasStore.command.RE_SEEK_AND_RENDER).catch((e) => {
            console.log(e);
          }).finally(() => {
            dispatch(this.setVideoSpeedAction(speed));
            dispatch(FJTimeLineAction.updateAllTimelineAction(true));
          })
        } else {
          FJMessageStore.addMessage(FJLocalStore._('playback-rate-min-limit'), 'error');
        }
      };
    },

		/**
		 * @description 设置透明度
		 * @param type
		 * @param value
		 * @returns {function(...[*]=)}
		 */
		changeOpacityValueAction: function(type, value) {
			return (dispatch) => {
				FJUtil.toggleScope(type);
				dispatch(this.setMediaOpacityAction(value))
				FJCanvasStore.executeSync(FJCanvasStore.command.SET_MEDIA_OPACITY_DATA, type, value)
			}
		},

		/**
		 * @description 更新透明度
		 * @param value
		 * @returns {{opacityValue: *, type: string}}
		 */
		setMediaOpacityAction: function(value) {
			return {
				type: FJActionConstant.SET_MEDIA_OPACITY_VALUE,
				opacityValue: value,
			}
		},

    /**
     * @description 更新video音量
     * @param value
     * @returns {{volume: *, type: string}}
     */
    setVideoVolumeAction: function (value) {
      return {
        type: FJActionConstant.SET_VIDEO_VOLUME,
        volume: value,
      }
    },

    /**
     * @description 更新视频音量
     * @return {{volume, type: string}}
     */
    setVideoSpeedAction: function (speed) {
      return {
        type: FJActionConstant.SET_VIDEO_SPEED,
        speed,
      }
    },

    /**
     * @description video设置缩放
     * @param type
     * @param value
     * @returns {Function}
     */
    videoZoomDataChangeAction: function (type, value) {
      return (dispatch) => {
        FJUtil.toggleScope(type);
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_VIDEO_ATTRIBUTES_DATA, {scale: value}, {
          type,
        });

        if (type === 'slideStop') {
          FJUtil.ealog('timeline_tool_zoom_use', {
            location: 'video',
          });
        }

        dispatch(this.setVideoZoomScaleAction(value)); // 更新界面
      }
    },

    /**
     * @description 更新video缩放值
     * @param value
     * @returns {{zoomScale: *, type: string}}
     */
    setVideoZoomScaleAction: function (value) {
      return {
        type: FJActionConstant.SET_VIDEO_ZOOM_SCALE,
        zoomScale: value,
      }
    },

    /**
     * @description video修改适配方式
     * @param type {String} FJCoreConstant.FIT, FJCoreConstant.FILL
     * @returns {Function}
     */
    videoAdaptiveChangeAction: function (type) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_VIDEO_ATTRIBUTES_DATA, {adaptive: type});
        FJUtil.ealog('timeline_tool_zoom_use', {
          location: 'video',
        });
        dispatch(this.updateToolbarAction());
      }
    },

    /**
     * @description audio设置音量
     * @param type
     * @param volume
     * @returns {Function}
     */
    audioVolumeDataChangeAction: function (type, volume) {
      return (dispatch) => {
        FJUtil.toggleScope(type);
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_AUDIO_ATTRIBUTES_DATA, {volume: volume / 100}, {
          type,
        });

        if (type === 'slideStop') {
          FJUtil.ealog('timeline_adjust_volume', {
            location: 'toolbar',
          });
        }

        dispatch(this.setAudioVolumeAction(volume));
      };
    },

    /**
     * @description audio设置淡入
     * @param type
     * @param value
     * @returns {{}}
     */
    audioFadeInDataChangeAction: function (type, value) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_AUDIO_ATTRIBUTES_DATA, {fadeIn: value}, {type});
        dispatch(this.setAudioFadeInAction(value))
      }
    },

    /**
     * @description audio设置淡出
     * @param type
     * @param value
     * @returns {{}}
     */
    audioFadeOutDataChangeAction: function (type, value) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_AUDIO_ATTRIBUTES_DATA, {fadeOut: value}, {type});
        dispatch(this.setAudioFadeOutAction(value))
      }
    },

    /**
     * @description 更新audio音量
     * @param value
     * @returns {{volume: *, type: string}}
     */
    setAudioVolumeAction: function (value) {
      return {
        type: FJActionConstant.SET_AUDIO_VOLUME,
        volume: value,
      }
    },

    /**
     * @description 更新audio淡入
     * @param value
     * @returns {{volume: *, type: string}}
     */
    setAudioFadeInAction: function (value) {
      return {
        type: FJActionConstant.SET_AUDIO_FADE_IN,
        fadeIn: value,
      }
    },

    /**
     * @description 更新audio淡出
     * @param value
     * @returns {{volume: *, type: string}}
     */
    setAudioFadeOutAction: function (value) {
      return {
        type: FJActionConstant.SET_AUDIO_FADE_OUT,
        fadeOut: value,
      }
    },

    /**
     * @description photo设置缩放
     * @param type
     * @param value
     * @returns {Function}
     */
    photoZoomDataChangeAction: function (type, value) {
      return (dispatch) => {
        FJUtil.toggleScope(type);
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_PHOTO_ATTRIBUTES_DATA, {scale: value}, {
          type,
        });

        if (type === 'slideStop') {
          FJUtil.ealog('timeline_tool_zoom_use', {
            location: 'photo',
          });
        }

        dispatch(this.setPhotoZoomScaleAction(value)); // 更新界面
      }
    },

    /**
     * @description 更新photo缩放值
     * @param value
     * @returns {{zoomScale: *, type: string}}
     */
    setPhotoZoomScaleAction: function (value) {
      return {
        type: FJActionConstant.SET_PHOTO_ZOOM_SCALE,
        zoomScale: value,
      }
    },

    photoAnimationChangeAction: function (type) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_PHOTO_ATTRIBUTES_DATA, {animationType: type});
        dispatch(this.setPhotoAnimationAction(type)); // 更新界面
      }
    },

    setPhotoAnimationAction: function (type) {
      return {
        type: FJActionConstant.SET_PHOTO_ANIMATION_SLOT,
        animationSelected: type,
      }
    },

    /**
     * @description photo修改适配方式
     * @param type {String} FJCoreConstant.FIT, FJCoreConstant.FILL
     * @returns {Function}
     */
    photoAdaptiveChangeAction: function (type) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_PHOTO_ATTRIBUTES_DATA, {adaptive: type});
        FJUtil.ealog('timeline_tool_zoom_use', {
          location: 'photo',
        });
        dispatch(this.updateToolbarAction());
      }
    },

    /**
     * @description 设置编辑模式
     * @return {function(*): void}
     */
    toggleEditorModeAction: function () {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.TOGGLE_EDIT_MODE);
        dispatch(this.updateToolbarAction());
      }
    },

    /**
     * @description 更新编辑模式状态
     * @param isEditMode
     * @return {{isEditMode: *, type: string}}
     */
    setEditorModeAction: function (isEditMode) {
      return {
        type: FJActionConstant.SET_EDIT_MODE,
        isEditMode,
      }
    },

    /**
     * @description 更新是否显示编辑模式按钮
     * @param isShowEditMode
     * @returns {{isShowEditMode: *, type: string}}
     */
    setShowEditorModeAction: function (isShowEditMode) {
      return {
        type: FJActionConstant.SET_SHOW_EDIT_MODE,
        isShowEditMode,
      }
    },

    /**
     * @description 设置背景色
     * @param type
     * @param color
     * @returns {Function}
     */
    setBackgroundColorAction: function (type, color) {
      return (dispatch) => {
        FJUtil.toggleScope(type);
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_BACKGROUND_COLOR_ATTRIBUTES_DATA, {backgroundColor: color}, {
          type,
        });
        dispatch(this.updateBackgroundColorAction(color));
        dispatch(FJTimeLineAction.updateAllTimelineAction());
      }
    },

    /**
     * @description 更新 BackgroundColor 颜色
     * @param color
     * @return {{color1: *, color2: *, type: string}}
     */
    updateBackgroundColorAction: function (color) {
      return {
        type: FJActionConstant.SET_BACKGROUND_COLOR_BACKGROUND_COLOR,
        backgroundColor: color,
      };
    },

    /**
     * @description 切换crop状态
     * @param cropMode {boolean}
     * @param shouldRecordCropData
     */
    setCropAction: function (cropMode, shouldRecordCropData) {
      return (dispatch, getState) => {
        const {selectedId} = getState().timeline;
        dispatch(FJPreviewAction.setVideoPauseAction());
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_GRAPH_CROP_MODE, selectedId, cropMode, shouldRecordCropData);
        dispatch(this.updateToolbarAction());
        if (cropMode) {
          dispatch(FJResourceAction.resetResourcePanelByToolbar());
        }
      };
    },

    /**
     * @description 设置裁切类型
     * @param {number} maskType
     */
    changeMaskAction: function (maskType) {
      return (dispatch, getState) => {
        let {selectedId} = getState().timeline;
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_GRAPH_CROP_TYPE, selectedId, maskType);
      };
    },

    /**
     * @description 设置裁切模式
     * @param cropMode
     */
    setCropModeAction: function (cropMode) {
      return {
        type: FJActionConstant.SET_CROP_MODE,
        cropMode,
      }
    },

    /**
     * @description 改变裁切类型
     * @param {number} maskType
     */
    setMaskAction: function (maskType) {
      return {
        type: FJActionConstant.SET_MASK_TYPE,
        maskType,
      }
    },

    /**
     * @description 设置mask是否可用
     * @param couldMask
     * @return {{type: string, couldMask: *}}
     */
    setMaskEnableAction: function (couldMask) {
      return {
        type: FJActionConstant.SET_MASK_ENABLE,
        couldMask,
      }
    },

    /**
     * @description 设置资源状态
     * @param type
     * @param mediaStatus
     */
    setMediaStatusAction: function (type, mediaStatus) {
      let {VIDEO, IMAGE, STATIC_IMAGE, AUDIO} = FJCoreConstant
      switch (type) {
        case VIDEO:
          return {
            type: FJActionConstant.SET_VIDEO_MEDIA_STATUS,
            mediaStatus,
          }
        case IMAGE:
          return {
            type: FJActionConstant.SET_PHOTO_MEDIA_STATUS,
            mediaStatus,
          }
        case STATIC_IMAGE:
          return {
            type: FJActionConstant.SET_OVERLAY_MEDIA_STATUS,
            mediaStatus,
          }
        case AUDIO:
          return {
            type: FJActionConstant.SET_AUDIO_MEDIA_STATUS,
            mediaStatus,
          }
      }
    },

		/**
		 * @description 设置资源名称
		 * @param type
		 * @param mediaName
		 */
		setMediaNameAction: function(type, mediaName) {
			let {VIDEO, IMAGE, AUDIO} = FJCoreConstant
			switch (type) {
				case VIDEO:
					return {
						type: FJActionConstant.SET_VIDEO_MEDIA_NAME,
						mediaName,
					}
				case IMAGE:
					return {
						type: FJActionConstant.SET_IMAGE_MEDIA_NAME,
						mediaName,
					}
				case AUDIO:
					return {
						type: FJActionConstant.SET_AUDIO_MEDIA_NAME,
						mediaName,
					}
			}
		},

		/**
		 * @description 设置旋转/翻转
		 * @param type
		 * @returns {function(...[*]=)}
		 */
		transformChangeAction: function (type) {
			return (dispatch, getState) => {
				let {selectedId} = getState().timeline;
				FJCanvasStore.executeSync(FJCanvasStore.command.SET_TRANSFORM, type, selectedId);
			};
		}
  }
})();

export default FJToolbarAction;
